import React, { useEffect, useState } from 'react'
import { IEpiProps, IEventRegistrationRefreshModel, IRenewalEligibilityResponse, ISpecialtyProgram, StepConstants } from '../models/event-reg-refresh-models'
import { useEventRegRefreshContext } from '../reducers/event-reg-refresh-reducers'
import { Alert } from './alert'
import { LoadingSpinner } from './loading-spinner'
import { getProgramsWithCompareDetails } from '../helpers/helpers'

interface IContextProps {
  epiProps: IEpiProps
  currentStep: string
  eventRegistrationRefreshModel: IEventRegistrationRefreshModel
}

interface IProps {
  programs: ISpecialtyProgram[]
  selectedProgramCode?: string
  unavailableProgramCodes: string[]
  onProgramSelect: (programCode: string) => void
}

export const CompareToolItem = (props: IProps) => {
  const { epiProps }: IContextProps = useEventRegRefreshContext()!
  const programsWithCompareDetails = getProgramsWithCompareDetails(props.programs);

  // Filter out unavailable programs
  const availablePrograms = programsWithCompareDetails.filter(program =>
    !props.unavailableProgramCodes.includes(program.programCode)
  );

  // Find the selected program object
  const selectedProgram = props.selectedProgramCode
    ? programsWithCompareDetails.find(p => p.programCode === props.selectedProgramCode)
    : availablePrograms[0] || null;

  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false)

  const handleProgramSelect = (program: ISpecialtyProgram) => {
    props.onProgramSelect(program.programCode)
    setIsDropdownOpen(false)
  }

  if (availablePrograms.length === 0) {
    return null
  }

  return (
    <div className="compare-tool-item">
      <div className="app-dropdown-container">

        {/*Custom Dropdown with program name & image*/}
        <button className="app-dropdown-toggle" aria-expanded={isDropdownOpen} onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
          <div className="app-dropdown-toggle-inner">
            {selectedProgram?.imageUrl && <img className="app-dropdown-toggle-image" src={selectedProgram.imageUrl} alt={selectedProgram.programImageAlternateText} />}
            <span className="app-dropdown-toggle-text">
              {selectedProgram?.programName}
            </span>
          </div>
          <svg className="svg-icon" aria-hidden="true" focusable="false">
            <use xmlnsXlink="http://www.w3.org/2000/xlink" xlinkHref="#icon-chevron-down" />
          </svg>
        </button>
        {isDropdownOpen && (
          <div className="app-dropdown-panel">
            {availablePrograms.map((program) => (
              <button
                key={program.programCode}
                className="compare-tool-item-option"
                style={{ cursor: 'pointer' }}
                tabIndex={0}
                onClick={() => handleProgramSelect(program)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault()
                    handleProgramSelect(program)
                  }
                }}
              >
                {program.imageUrl && <img className="compare-tool-item-option-image" src={program.imageUrl} alt={program.programImageAlternateText} />}
                <span>{program.programName}</span>
              </button>
            ))}
          </div>
        )}
      </div>
      {/*End Custom Dropdown with program name & image*/}

      {/*Program Details*/}
      <div className="compare-tool-item-desc">
        {selectedProgram?.mainFeatures && selectedProgram.mainFeatures.length > 0 && (
          <div>
            <p><strong>{epiProps.mainFeaturesHeaderText}</strong></p>
            <ul>
              {selectedProgram.mainFeatures.map((feature, index) => (
                <li className="card-feature-list-item" key={index}><svg className="svg-icon" aria-hidden="true" focusable="false">
                  <use xmlnsXlink="ttp://www.w3.org/2000/xlink" xlinkHref="#icon-checkmark" />
                </svg><span>{feature}</span></li>
              ))}
              {selectedProgram.additionalFeatures.map((feature, index) => (
                <li className="card-feature-list-item" key={index}><svg className="svg-icon" aria-hidden="true" focusable="false">
                  <use xmlnsXlink="ttp://www.w3.org/2000/xlink" xlinkHref="#icon-checkmark" />
                </svg><span>{feature}</span></li>
              ))}
            </ul>
          </div>
        )}
      </div>


    </div>
  )
}